export function heroAudio() {
    const audio = document.getElementById("hero-audio");

    $('.sound-switcher button').on('click', function () {
        const $this = $(this);
        if (!$this.hasClass('off')) {
            $this.addClass('off');
            audio.muted = true;
        } else {
            $this.removeClass('off');
            audio.play();
            audio.muted = false;
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/hero-audio.js